
interface ServiceHeroProps {
  title: string;
  description: string;
  imageUrl?: string;
  imageAlt?: string;
}

export const ServiceHero = ({ title, description, imageUrl, imageAlt }: ServiceHeroProps) => {
  return (
    <div className="bg-gradient-to-b from-primary/20 to-background py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center space-y-4">
          <h1 className="text-4xl font-bold">{title}</h1>
          <p className="text-xl text-muted-foreground">
            {description}
          </p>
          {imageUrl && (
            <div className="mt-8">
              <img 
                src={imageUrl} 
                alt={imageAlt || title} 
                className="mx-auto rounded-lg shadow-md"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export type { ServiceHeroProps };
